import React from "react";

import { DateLiteral } from "@plex/culture-react";
import { DataTableDef } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import "ui/screens/security/index.module.scss";
import { useLocalizedValues, useLocalizer } from "ui/hooks";
import { securityMessages } from "ui/screens/security/security.localization";

import { IRoleAssignmentEvent } from "../RoleMembersHistory.state";

export interface IRoleMembersHistoryGrid {
  data?: IRoleAssignmentEvent[];
}

export const RoleMembersHistoryGrid: React.FC<IRoleMembersHistoryGrid> = ({ data }) => {
  const localizer = useLocalizer();

  const localizedValues = useLocalizedValues(() => ({
    refineSearch: commonMessages.info("refineSearch"),
    startSearch: commonMessages.info("startSearch"),
    account: securityMessages.property("account"),
    action: securityMessages.property("action"),
    updatedBy: securityMessages.property("updatedBy"),
    updatedDate: securityMessages.property("updatedDate")
  }));

  return (
    <DataTableDef<IRoleAssignmentEvent>
      data={data ? data : []}
      keySelector={row => row.committedTime}
      emptyText={data ? localizedValues.refineSearch : localizedValues.startSearch}
    >
      <DataTableDef.Column<IRoleAssignmentEvent> id="account" title={localizedValues.account} sortable valueSelector={row => row.account.accountName}>
        {row => row.account.accountName}
      </DataTableDef.Column>
      <DataTableDef.Column<IRoleAssignmentEvent> id="action" title={localizedValues.action} sortable valueSelector={row => row.action}>
        {row => localizer({ value: row.action })}
      </DataTableDef.Column>
      <DataTableDef.Column<IRoleAssignmentEvent> id="updatedBy" title={localizedValues.updatedBy} sortable valueSelector={row => row.author.accountName}>
        {row => row.author.accountName}
      </DataTableDef.Column>
      <DataTableDef.Column<IRoleAssignmentEvent> id="updatedDate" title={localizedValues.updatedDate} sortable valueSelector={row => row.committedTime}>
        {row => <DateLiteral value={new Date(row.committedTime)} options={{ datetime: "medium" }} />}
      </DataTableDef.Column>
    </DataTableDef>
  );
};
